<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <KeyValuesForm :baseKeyValuePair="keyValue" :loading="loading" @submit-requested="submitRequested"></KeyValuesForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import KeyValuesForm from './KeyValuesForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            keyValue: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { KeyValuesForm },
    computed:
    {
        ...mapState('keyValues', ['getKeyValueDetailsOutput']),
    },
    methods: {
        ...mapActions('keyValues', ['getKeyValueDetails']),
        ...mapActions('keyValues', ['putKeyValue']),
        submitRequested(keyValues) {
            this.putKeyValue(keyValues);
        },
    },
    mounted: function () {
        if (!this.$route.query.key) {
            router.push({ name: 'KeyValuesList' });
        }

        this.getKeyValueDetails(this.$route.query.key);
    },
    watch:
    {
        getKeyValueDetailsOutput: function(keyValueOutput)
        {
            if(!keyValueOutput && !keyValueOutput.data)
            {
                router.push({ name: 'KeyValuesList' });
            }
            else
            {
                this.keyValue = keyValueOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>